<template>
    <div class="container mx-auto px-8 grid grid-cols-5 gap-4">
        <div class="col-span-5">
            <HeaderComponent :title="`Edit Signup Form for Affiliate: ${affiliate.name}`" :actions="[
                {label: 'Edit Form', click: () => router.get(`/affiliates/${affiliate.short_uuid}/edit`), class: 'bg-blue-500 text-white'}, 
                {label: 'View Signup Form', click: () => router.get(`/sign-up/${affiliate.short_uuid}`), class: 'bg-blue-500 text-white'},
                {label: 'Save', click: () => submit(), class: 'bg-green-500 text-white'},
            ]"/>
        </div>
        <div class="col-span-1 flex flex-col gap-4" v-if="affiliate.parent_id === null">
            <h3 class="text-lg font-bold">Add Input Types</h3>
            <div v-for="(type, name) in inputTypes" :key="name" class="bg-gray-200 hover:bg-gray-300 cursor-pointer p-4 rounded-sm h-8 flex items-center justify-center" @click="addInputType(type)">
                <div class="text-sm font-bold">{{ name }}</div>
            </div>
        </div>
        <div class="col-span-2"  v-if="affiliate.parent_id === null">
            <JsonEditorVue
                v-model="schema"
                class="w-full h-full"
            ></JsonEditorVue>
        </div>
        <div class="col-span-2 relative p-8 border border-gray-200 rounded-sm"  v-if="affiliate.parent_id === null">
            <FormKit
                @submit="fakeSubmit"
                type="form"
                id="editor-form"
                class="relative z-20"
            >
                <FormKitSchema :schema="schema" />
            </FormKit>
        </div>
    </div>
</template>

<script setup>
import { FormKit, FormKitSchema, reset } from "@formkit/vue";
import { usePage, router } from "@inertiajs/vue3";
import { computed } from "vue";
import { toast } from "vue3-toastify";
import JsonEditorVue from "json-editor-vue";
import HeaderComponent from "@/Components/HeaderComponent.vue";

const page = usePage();
const affiliate = computed(() => page.props.affiliate);

const inputTypes = {
    text: {
        $formkit: "text",
        label: "Text",
        name: "text",
        validation: "required",
    },
    img: {
        $el: "img",
        attrs: {
            src: "https://via.placeholder.com/150",
        },
    },
    email: {
        $formkit: "email",
        label: "Email",
        name: "email",
        validation: "required|email",
    },
    checkbox: {
        $formkit: "checkbox",
        label: "Checkbox",
        name: "checkbox",
        validation: "required",
    },
    tel: {
        $formkit: "tel",
        name: "tel",
        label: "*Telephone",
        placeholder: "xxx-xxx-xxxx",
        help: "Phone number must be in the xxx-xxx-xxxx format.",
        validation: "required|matches:/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/",
    },
    date: {
        $formkit: "date",
        label: "Date",
        name: "date",
        validation: "required",
    },
    textarea: {
        $formkit: "textarea",
        label: "Description",
        name: "description",
        help: "Must be between 20 and 500 characters.",
        placeholder: "Enter your description here.",
        validation: "required|length:20,500",
    },
    password: {
        $formkit: "password",
        label: "Password",
        name: "password",
        validation: "required",
    },
};

const addInputType = (type) => {
    schema.value = [...schema.value, type];
};

const schema = computed({
    get: () => JSON.parse(affiliate.value.signup_formkit_schema) ?? [],
    set: (value) => {
        let tempVal;
        try {
            tempVal = typeof value === "object" ? JSON.stringify(value) : value;
            JSON.parse(tempVal); // Check if tempVal is valid JSON
        } catch (e) {
            return;
            // do nothing. probably not valid json yet
        }
        affiliate.value.signup_formkit_schema = tempVal;
    },
});

const fakeSubmit = () => {
    toast("Submitted", {
        type: "success",
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
    });
    reset("editor-form");
};

const submit = () => {
    router.post(window.location.href, page.props.affiliate, {
        headers: {
            "X-CSRF-Token": usePage().props.csrfToken,
        },
    });
};
</script>
